var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRowVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.875 16.875H5.125C3.25 16.875 2.5 17.675 2.5 19.6625V24.7125C2.5 26.7 3.25 27.5 5.125 27.5H24.875C26.75 27.5 27.5 26.7 27.5 24.7125V19.6625C27.5 17.675 26.75 16.875 24.875 16.875Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 2.5H5.125C3.25 2.5 2.5 3.3 2.5 5.2875V10.3375C2.5 12.325 3.25 13.125 5.125 13.125H24.875C26.75 13.125 27.5 12.325 27.5 10.3375V5.2875C27.5 3.3 26.75 2.5 24.875 2.5Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowVertical);
export default __webpack_public_path__ + "static/media/row-vertical.0c571c525e0aa60c3e35b7b65a7588c1.svg";
export { ForwardRef as ReactComponent };